import React from 'react';
import { Flex, Select, Typography } from 'antd';
import { FormikProps } from 'formik';

import { IProducts } from '../../../../shops/features/products/service/products.interface';
import { ShopOrderType } from '../../../../shops/features/shops/service/shop.interface';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../../../shops/features/shops/store/shopSlice';

const filterOption = (
    input: string,
    option?: { label: string; value: string }
) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

const options: Array<{ value: boolean | string; label: string }> = [
    {
        value: true,
        label: ShopOrderType.pay,
    },
    {
        value: false,
        label: ShopOrderType.preorder,
    },
];

interface Props {
    readonly formik: FormikProps<IProducts>;
    readonly width?: number;
    readonly isDisabled?: boolean;
}
export const BuyableSwitcher = ({ formik, isDisabled, width }: Props) => {
    const current = useAppSelector(selectShopCurrent);

    if (!current) return;

    return (
        <Flex gap={8} vertical>
            <Typography.Text>Оформление товара</Typography.Text>
            <Select
                disabled={!current?.buyable || isDisabled}
                style={{
                    width: width,
                }}
                showSearch
                defaultValue={formik?.values?.buyable}
                placeholder='Выберите способ оплаты'
                optionFilterProp='children'
                onChange={value => formik.setFieldValue('buyable', value)}
                filterOption={filterOption}
                options={options}
            />
        </Flex>
    );
};
